"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ListItem", {
  enumerable: true,
  get: function get() {
    return _ListItem.default;
  }
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _View = _interopRequireDefault(require("@instructure/ui-layout/lib/components/View"));

var _uiThemeable = _interopRequireDefault(require("@instructure/ui-themeable"));

var _passthroughProps = require("@instructure/ui-utils/lib/react/passthroughProps");

var _uiPropTypes = require("@instructure/ui-prop-types");

var _ThemeablePropTypes = _interopRequireDefault(require("@instructure/ui-themeable/lib/utils/ThemeablePropTypes"));

var _safeCloneElement = _interopRequireDefault(require("@instructure/ui-utils/lib/react/safeCloneElement"));

var _uiTestable = _interopRequireDefault(require("@instructure/ui-testable"));

var _ListItem = _interopRequireDefault(require("./ListItem"));

var _theme = _interopRequireDefault(require("./theme"));

var _dec, _dec2, _class, _class2, _temp;

var styles = {
  componentId: 'tTloz',
  template: function template(theme) {
    return "\n\n.tTloz_bGBk{font-family:".concat(theme.fontFamily || 'inherit', ";font-weight:").concat(theme.fontWeight || 'inherit', ";padding:0}\n\n.tTloz_ddES{-webkit-padding-end:0;-webkit-padding-start:").concat(theme.defaultListPadding || 'inherit', ";padding-inline-end:0;padding-inline-start:").concat(theme.defaultListPadding || 'inherit', "}\n\n[dir=ltr] .tTloz_ddES{padding-left:").concat(theme.defaultListPadding || 'inherit', ";padding-right:0}\n\n[dir=rtl] .tTloz_ddES{padding-left:0;padding-right:").concat(theme.defaultListPadding || 'inherit', "}\n\n.tTloz_ddES.tTloz_enMC{-webkit-padding-end:0;-webkit-padding-start:calc(").concat(theme.defaultListPadding || 'inherit', "/2);counter-reset:ol-counter;list-style-type:none;padding-inline-end:0;padding-inline-start:calc(").concat(theme.defaultListPadding || 'inherit', "/2)}\n\n[dir=ltr] .tTloz_ddES.tTloz_enMC{padding-left:calc(").concat(theme.defaultListPadding || 'inherit', "/2);padding-right:0}\n\n[dir=rtl] .tTloz_ddES.tTloz_enMC{padding-left:0;padding-right:calc(").concat(theme.defaultListPadding || 'inherit', "/2)}\n\n.tTloz_ddES.tTloz_enMC li:before{-webkit-margin-end:").concat(theme.orderedNumberMargin || 'inherit', ";-webkit-margin-start:0;content:counters(ol-counter,\".\") \".\";counter-increment:ol-counter;font-weight:").concat(theme.orderedNumberFontWeight || 'inherit', ";margin-inline-end:").concat(theme.orderedNumberMargin || 'inherit', ";margin-inline-start:0}\n\n[dir=ltr] .tTloz_ddES.tTloz_enMC li:before{margin-left:0;margin-right:").concat(theme.orderedNumberMargin || 'inherit', "}\n\n[dir=rtl] .tTloz_ddES.tTloz_enMC li:before{margin-left:").concat(theme.orderedNumberMargin || 'inherit', ";margin-right:0}\n\n.tTloz_eXrk,.tTloz_fLbg{-webkit-padding-start:0;list-style-type:none;padding-inline-start:0}\n\n[dir=ltr] .tTloz_eXrk,[dir=ltr] .tTloz_fLbg{padding-left:0}\n\n[dir=rtl] .tTloz_eXrk,[dir=rtl] .tTloz_fLbg{padding-right:0}");
  },
  'root': 'tTloz_bGBk',
  'default': 'tTloz_ddES',
  'ordered': 'tTloz_enMC',
  'inline': 'tTloz_eXrk',
  'unstyled': 'tTloz_fLbg'
};
var List = (
/**
---
category: components
---
**/
_dec = (0, _uiTestable.default)(), _dec2 = (0, _uiThemeable.default)(_theme.default, styles), _dec(_class = _dec2(_class = (_temp = _class2 =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(List, _Component);

  function List() {
    (0, _classCallCheck2.default)(this, List);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(List).apply(this, arguments));
  }

  (0, _createClass2.default)(List, [{
    key: "renderChildren",
    value: function renderChildren() {
      var _this = this;

      return _react.Children.map(this.props.children, function (child) {
        if (!child) return; // ignore null, falsy children

        return (0, _safeCloneElement.default)(child, {
          variant: _this.props.variant,
          delimiter: _this.props.delimiter,
          size: _this.props.size,
          spacing: _this.props.itemSpacing
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _classes;

      var passthroughProps = _View.default.omitViewProps((0, _passthroughProps.omitProps)(this.props, List.propTypes), List);

      var _this$props = this.props,
          as = _this$props.as,
          margin = _this$props.margin,
          variant = _this$props.variant,
          elementRef = _this$props.elementRef;
      var classes = (_classes = {}, (0, _defineProperty2.default)(_classes, styles.root, true), (0, _defineProperty2.default)(_classes, styles[variant], variant), (0, _defineProperty2.default)(_classes, styles.unordered, as === 'ul'), (0, _defineProperty2.default)(_classes, styles.ordered, as === 'ol'), _classes);
      return _react.default.createElement(_View.default, Object.assign({}, passthroughProps, {
        className: (0, _classnames.default)(classes),
        as: as,
        margin: margin,
        elementRef: elementRef
      }), this.renderChildren());
    }
  }]);
  List.displayName = "List";
  return List;
}(_react.Component), _class2.propTypes = {
  /**
  * Only accepts <ListItem> as a child
  */
  children: _uiPropTypes.Children.oneOf([_ListItem.default]),
  as: _propTypes.default.oneOf(['ul', 'ol']),

  /**
  * Valid values are `0`, `none`, `auto`, `xxx-small`, `xx-small`, `x-small`,
  * `small`, `medium`, `large`, `x-large`, `xx-large`. Apply these values via
  * familiar CSS-like shorthand. For example: `margin="small auto large"`.
  */
  margin: _ThemeablePropTypes.default.spacing,
  size: _propTypes.default.oneOf(['small', 'medium', 'large']),
  variant: _propTypes.default.oneOf(['default', 'unstyled', 'inline']),
  delimiter: _propTypes.default.oneOf(['none', 'pipe', 'slash', 'arrow', 'dashed', 'solid']),

  /**
  * Sets the margin separating each ListItem.
  */
  itemSpacing: _propTypes.default.oneOf(['none', 'xxx-small', 'xx-small', 'x-small', 'small', 'medium', 'large', 'x-large', 'xx-large']),
  elementRef: _propTypes.default.func
}, _class2.defaultProps = {
  children: null,
  itemSpacing: void 0,
  elementRef: void 0,
  as: 'ul',
  margin: 'none',
  variant: 'default',
  delimiter: 'none',
  size: 'medium'
}, _temp)) || _class) || _class);
exports.default = List;